import { generateTypes } from '../../utils/HttpReducerHelper';

export const loginOpenId = generateTypes('OPEN_ID', 'LOGIN');
export const openId = generateTypes('OPEN_ID', 'OPENID');
export const signupOpenId = generateTypes('OPEN_ID', 'SIGNUP');
